import compileSymbols from '~/utils/compileSymbols';

var types = ['TOGGLE_CONTEXTUAL', 'TOGGLE_CANVAS_BLUR'];

export default compileSymbols(types, 'menu');
